export const storageKey = {
  lang: 'langCode',
  userInfo: 'userInfo',
};

export const routePath = {
  pyxisPortalPath: '/pyxis-portal',
};
